<template>
  <div class="dashboard background">
    <toast />
    <dashboard-page pcontent="1" page="GRADES">
      <card w='80%' minWidth='950px'>
        <!-- card header -->
        <div class='fRow fullWidth jStart aStart'>
          <div class='growFull fCol jStart aStart'>
            <h3 class='growFull text-right'>مدیریت رشته‌های تحصیلی</h3>
            <p class='note'>پایه‌های تحصیلی را اضافه، حذف، ویرایش و مشاهده کنید.</p>
          </div>
          <btn fabBtn='true'
            v-if="false"
            label='به روز رسانی'
            bc='#9a9a9a'
            style="margin-right: 8px !important;"
            icon='loop' @click.native="refreshAll"/>
        </div>
        <!-- اضافه کردن رشته -->
        <div class="fullWidth fCol jStart aStart inputHolder addBox"
          ref="top"
          style="margin-top: 24px;">
          <h2 class="fRow jStart aCenter">
            <i class="material-icons-round">add</i>
            ایجاد رشته‌ی جدید</h2>
          <span class="fRow jStart aCenter">
            <i class="material-icons-round">category</i>
            نام رشته</span>
          <div class="fRow jStart aCenter fullWidth inputWraper">
            <input class="transition-fast growFull"
              placeholder="نام رشته"
              @keyup.enter="newField"
              type="text" v-model="fieldName"/>
            <switch-button
              activeLabel="فعال"
              deactiveLabel="غیرفعال"
              style="margin: 0 16px"
              @click.native="fieldStatus = !fieldStatus"
              :val="fieldStatus" />
            <div class="b fRow jStart aCenter"
              @click="newField"
              v-bind:class="{active: fieldName.length > 0}">
              <i class="material-icons-round">add</i>
              <label>اضافه کردن رشتــه</label>
            </div>
          </div>
        </div>
        <div class='sepLine'></div>
        <!-- grid header -->
        <div class='gridHead gridRow fRow jBetween fullWidth'>
          <div class='tableHead growFull'>رشته</div>
          <!-- <div class='tableHead itemImg'>تصویر</div> -->
          <div class='tableHead state'>وضعیت</div>
          <div class='tableHead actions'>عملیات</div>
        </div>
        <div class="fCol jCenter aCenter selectField fullWidth"
          v-if="isFirstLoad && isDataLoad">
          <i class="material-icons-round">info</i>
          <span>لطفا صبر کنید</span>
        </div>
        <empty-bar v-if="responseEmpty" w='100%' h='152px'
          msg='شما هنوز هیچ رشته ای ثبت نکرده اید' empt='true'/>
        <error-bar v-if="responseError" w='100%' h='152px'
          :msg='errorMsg' err='true'/>
        <progress-bar v-if="!isDataLoad" w='100%' h='160px'
          msg='لطفا صبر کنید' load='true'/>
        <div class="fullWidth fCol aCenter jStart" v-if="false">
          <grade-row
            v-bind:key="item.id"
            v-for="item in fieldsData.data"
            :gradesData='item' />
        </div>
        <!-- list -->
        <div class="fullWidth fCol aCenter jBetween results" v-if="isDataLoad">
          <div v-for="(item, index) in fieldsData.data" v-bind:key="index"
            class="fullWidth fRow jBetween aCenter fieldRow transition-fast"
              v-bind:class="{editMode: editIndex === index,
              deleteMode: deleteIndex === index}">
            <div class="fieldName growFull">
              <input type="text"
                class="fullWidth transition-fast"
                v-model="fieldsData.data[index].title"
                @keyup.enter="saveEdits(index)"
                :id="`item${index}`"
                :disabled="index !== editIndex" />
            </div>
            <div class="fieldStatus state fRow jCenter aCenter">
              <switch-button
                activeLabel="فعال"
                deactiveLabel="غیرفعال"
                @click.native="changeStatus(index)"
                :val="item.status" />
            </div>
            <div class="actions fRow jCenter aCenter">
              <!-- ویرایش -->
              <i class="material-icons-round"
                v-if="editIndex !== index"
                @click="edit(index)">edit</i>
              <!-- حذف -->
              <i class="material-icons-round"
                @click="deleteItem(index)"
                v-if="editIndex !== index">delete</i>
              <!-- کنسل کردن ویرایش -->
              <i class="material-icons-round"
                v-if="editIndex === index"
                @click="discardEdits(index)">close</i>
              <!-- ذخیره -->
              <i class="material-icons-round save"
                v-if="editIndex === index"
                @click="saveEdits(index)">save</i>
            </div>
            <div class="deleteDialoge fRow jStart aCenter"
              v-if="deleteIndex === index">
              <span>آیا از حذف رشتۀ {{item.title}} مطمئنید؟</span>
              <div class="textBtn fRow jStart aCenter"
                @click="deleteField(index)">
                <i class="material-icons-round">delete_sweep</i>
                <label>بله حذف شود</label>
              </div>
              <div class="textBtnFlat fRow jStart aCenter"
                @click="deleteIndex = -1">
                <i class="material-icons-round">close</i>
                <label>خیر، انصراف</label>
              </div>
            </div>
          </div>
        </div>
      </card>
      <modal v-if="computedModalState" @changeMsg="refreshAll()">
        <card :w="`${computedCardWidth}`">
        <!-- add / edit permission -->
          <grade-manager v-if="computedWorkOn" @changeMsg="refreshAll()"
          :mode='computedMode'/>
        </card>
      </modal>
    </dashboard-page>
    <tool-bar/>
    <right-menu/>
  </div>
</template>

<script>
import SwitchButton from '@/components/SwitchButton.vue';
import RightMenu from '@/components/RightMenu.vue';
import ToolBar from '@/components/ToolBar.vue';
import DashboardPage from '@/components/DashboardPage.vue';
import Card from '@/components/Card.vue';
import Btn from '@/components/Btn.vue';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';
import fp from '@/mixins/fp';
import Toast from '@/components/Toast.vue';
import ProgressBar from '@/components/ProgressBar.vue';
import ErrorBar from '@/components/ErrorBar.vue';
import EmptyBar from '@/components/EmptyBar.vue';
import axios from 'axios';
import Modal from '@/components/Modal.vue';
// کامپوننت های مربوط به Grade
import GradeRow from '@/components/grades/GradeRow.vue';
import GradeManager from '@/components/grades/GradeManager.vue';

export default {
  mixins: [errorHandler, makeToast, fp],
  data() {
    return {
      isDataLoad: true,
      isFirstLoad: true,
      responseFalse: false,
      responseError: false,
      responseEmpty: false,
      selectedFieldToShow: 0,
      baseURL: this.$store.state.baseUrl,
      fieldName: '',
      fieldNameErr: true,
      fieldStatus: true,
      V: this.$store.state.apiVersion,
      fieldsData: [],
      modalManager: this.$store.state.modalState,
      // list datas
      editIndex: -1,
      editTemp: '',
      deleteIndex: -1,
    };
  },
  methods: {
    refreshAll() {
      document.getElementById('all').click();
    },
    addGrade() {
      this.$store.commit('setWorkOn', 'grades');
      this.$store.commit('setGradeAddMode');
      this.$store.commit('openGradeCard', '');
    },
    getFields() {
      this.isDataLoad = false;
      this.responseFalse = false;
      this.responseEmpty = false;
      this.responseError = false;
      this.responseLoad = true;
      const reqUrl = `${this.baseURL}/api/v${this.V}/Fields`;
      // if (f !== -1) {
      //   reqUrl = `${this.baseURL}/api/v${this.V}/Grades?field=${f}`;
      // }
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        // JSON responses are automatically parsed.
        this.responseLoad = false;
        this.posts = response.data;
        this.isFirstLoad = false;
        if (this.posts.isSuccess) {
          // this.makeToast('info', 'اطلاعات پایه های تحصیلی با موفقیت دریافت شد', 2000);
          this.responseFalse = false;
          // اگه درست بود همه چی
          this.isDataLoad = true;
          this.fieldsData = JSON.parse(JSON.stringify(this.posts));
          this.scrollTop();
          // console.log('all grades data', this.fieldsData);
          // اگه لیست خالی بود
          if (this.posts.data.length === 0) {
            this.responseEmpty = true;
          } else {
            this.responseEmpty = false;
          }
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.responseError = true;
        this.isDataLoad = true;
        this.responseEmpty = false;
        this.responseFalse = false;
        this.responseLoad = false;
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    initUserData() {
      // این اول صفحه اجرا میشه
      if (this.$store.state.fp === 'undefined') {
        this.fpGenerator().then(() => {
          this.$authObeject.checkDate().then((result) => {
            if (result) {
              // console.log('توکن منقضی شده، درخواست ریفرش توکن');
            } else {
              this.initPage();
            }
          });
        });
      } else {
        this.initPage();
      }
    },
    initPage() {
      // اینیت اولیه پیج
      this.getFields();
    },
    newField() {
      if (this.fieldName.length > 0) {
        axios({
          method: 'post',
          url: `${this.baseURL}/api/v${this.V}/Fields`,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            title: this.fieldName,
            status: this.fieldStatus,
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            // console.log('created');
            // console.log(response.data);
            this.fieldName = '';
            this.scrollTop();
            this.getFields();
            this.makeToast('success', 'رشته با موفقیت ایجاد شد', 3000);
          } else {
            // this.responseFalse = true;
          }
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 3000);
        });
      } else {
        this.makeToast('warning', 'نام رشته را وارد کنید', 3000);
      }
    },
    edit(index) {
      this.editTemp = this.fieldsData.data[index].title;
      this.editIndex = index;
    },
    saveEdits(index) {
      const newTitle = this.fieldsData.data[index].title;
      const nId = this.fieldsData.data[index].id;
      // console.warn('تایتل جدید برای آپدیت ↓', index);
      // console.warn(newTitle);
      // save edits on server
      axios({
        method: 'put',
        url: `${this.baseURL}/api/v${this.V}/Fields/${nId}`,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        data: {
          title: newTitle,
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.editTemp = '';
          this.editIndex = -1;
          // console.log('created');
          // console.log(response.data);
          this.makeToast('success', 'رشته با موفقیت ویرایش شد', 3000);
          this.getFields();
        } else {
          // this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
      });
    },
    discardEdits(index) {
      this.fieldsData.data[index].title = this.editTemp;
      this.editIndex = -1;
    },
    deleteItem(index) {
      this.deleteIndex = index;
    },
    deleteField(index) {
      const [id] = [this.fieldsData.data[index].id];
      // save edits on server
      axios({
        method: 'delete',
        url: `${this.baseURL}/api/v${this.V}/Fields/${id}`,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        data: {
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.deleteIndex = -1;
          // console.log('created');
          // console.log(response.data);
          this.makeToast('success', 'رشته با موفقیت حذف شد', 3000);
          this.getFields();
        } else {
          // this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
      });
    },
    changeStatus(index) {
      const [id] = [this.fieldsData.data[index].id];
      const [nStatus] = [this.fieldsData.data[index].status];
      // save edits on server
      axios({
        method: 'patch',
        url: `${this.baseURL}/api/v${this.V}/Fields/${id}?status=${!nStatus}`,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.deleteIndex = -1;
          // console.log('created');
          // console.log(response.data);
          this.makeToast('success', 'رشته با موفقیت ویرایش شد', 3000);
          this.getFields();
        } else {
          // this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
      });
    },
    scrollTop() {
      const myEl = this.$refs.top;
      setTimeout(() => {
        // console.log(myEl);
        this.$smoothScroll({
          scrollTo: myEl,
          duration: 1000,
          offset: -50,
        });
      }, 900);
    },
  },
  mounted() {
    this.initUserData();
  },
  components: {
    ProgressBar,
    ErrorBar,
    EmptyBar,
    RightMenu,
    ToolBar,
    DashboardPage,
    Card,
    Btn,
    Toast,
    GradeRow,
    GradeManager,
    Modal,
    SwitchButton,
  },
  computed: {
    computedModalState() {
      return this.$store.state.modalState;
    },
    computedCardWidth() {
      let ww = '0';
      switch (this.$store.state.gradeManagerMode) {
        case 'add': {
          ww = '880px';
          break;
        }
        case 'edit': {
          ww = '710px';
          break;
        }
        case 'delete': {
          ww = '426px';
          break;
        }
        default:
          break;
      }
      // console.log(this.$store.state.permissionManagerMode, ww);
      return ww;
    },
    computedWorkOn() {
      let cwo = false;
      switch (this.$store.state.workOn) {
        case 'grades': {
          cwo = true;
          break;
        }
        default:
          break;
      }
      return cwo;
    },
    computedMode() {
      return this.$store.state.gradeManagerMode;
    },
  },
};
</script>

<style lang="scss" scoped>
$azadSecondary: #8e9bd6;
$azadPrimary: #2156ae;
$azadNormalText: #343434;
$azadDarkText: #131313;
$azadInvertText: #fafafa;
.filters {
  padding: 16px 0 0 0;
}
.addBox {
  padding: 16px;
  border-radius: 16px;
  border: solid 2px rgba($color: #000000, $alpha: 0.05);
  h2 {
    font-size: 16px;
    padding: 0;
    margin: 0 0 16px 0;
    i {
      color: rgba($color: #000000, $alpha: 0.25);
      margin-left: 8px;
    }
  }
}
.selectField {
  min-height: 112px;
  padding: 48px 24px;
  i {
    font-size: 96px;
    margin-bottom: 16px;
    color: #535353;
  }
  span {
    font-size: 18px;
    font-weight: 100;
    color: #535353;
  }
}
.filters label{
  width: 20%;
}
.inputHolder {
  margin-bottom: 4px;
  span {
    font-size: 12px;
    color: rgba($color: #888888, $alpha: 1.0);
    position: relative;
    i{
      color: $azadPrimary;
      font-size: 16px;
      margin-left: 8px;
    }
  }
  .inputWraper{
    position: relative;
    label{
      text-align: right;
      font-size: 12px;
      color: #888888;
    }
    input[type='number'], input[type='password'], input[type='text'], textarea{
      outline: none;
      -webkit-user-select: auto;
      -moz-user-select: auto;
      -ms-user-select: auto;
      user-select: auto;
      border: solid 2px rgba($color: $azadSecondary, $alpha: 0.25);
      padding: 3px 12px !important;
      text-align: right !important;
      margin: 8px 0px 8px 0 !important;
      font-size: 16px;
      font-weight: 300;
      letter-spacing: 0px;
      width: 100%;
      border-radius: 8px;
      color: $azadDarkText;
      resize: none;
      background-color: rgba(0, 0, 0, 0);
    }
    input[type='number']::placeholder,
    input[type='password']::placeholder,
    input[type='text']::placeholder,
    textarea::placeholder{
      font-weight: 100;
    }
    input[type='number']:disabled, input[type='password']:disabled, input[type='text']:disabled{
      font-size: 14px;
      opacity: 0.75;
    }
    textarea {
      max-height: 340px !important;
    }
  }
}
.results {
  position: relative;
  .fieldRow {
    position: relative;
    margin-top: 8px;
    padding: 8px 0;
    border-radius: 8px;
    overflow: hidden;
    border: solid 2px rgba($color: #000000, $alpha: 0);
    .fieldName {
      margin-left: 16px;
      input {
        padding: 8px 16px;
        border-radius: 4px;
        background-color: rgba($color: #000000, $alpha: 0.05);
        text-align: right;
        font-size: 14px;
        margin-right: 8px;
        outline: 0;
        border: none;
      }
      input:disabled {
        background-color: rgba($color: #000000, $alpha: 0) !important;
      }
    }
    .actions {
      i {
        font-size: 16px;
        margin-right: 4px;
        cursor: pointer;
      }
      i.save {
        background-color: rgb(54, 131, 54);
        color: white;
      }
    }
    .deleteDialoge {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: rgb(216, 38, 38);
      font-size: 14px;
      z-index: 30;
      padding: 0 16px;
      span {
        color: white;
        margin-left: 24px;
      }
      .textBtn {
        padding: 4px 8px;
        border-radius: 64px;
        background-color: white;
        margin-left: 16px;
        * {
          pointer-events: none;
        }
        cursor: pointer;
        i {
          color: rgb(212, 65, 65);
          margin-left: 8px;
          font-size: 16px;
        }
        label {
          color: rgb(54, 54, 54);
          font-size: 13px;
          font-weight: bold;
        }
      }
      .textBtnFlat {
        padding: 4px 8px;
        border-radius: 64px;
        background-color: rgba(255, 255, 255, 0.055);
        cursor: pointer;
        * {
          pointer-events: none;
        }
        i {
          color: rgba(255, 255, 255, 0.781);
          margin-left: 4px;
          font-size: 12px;
        }
        label {
          color: rgb(255, 255, 255);
          font-size: 12px;
          font-weight: bold;
        }
      }
    }
  }
  .fieldRow.editMode {
    background-color: rgba($color: #000000, $alpha: 0) !important;
    border: solid 2px rgba(54, 131, 54, 0.521);
    z-index: 20;
    box-shadow: 0 0 64px 12px rgba($color: #000000, $alpha: 0.45),
      0 0 0 8px rgba($color: #000000, $alpha: 0.10),
      0 0 0 4px rgba($color: #000000, $alpha: 0.10),
      0 0 0 2px rgba($color: #000000, $alpha: 0.10);
  }
  .fieldRow.deleteMode {
    background-color: rgba($color: #000000, $alpha: 0) !important;
    border: none;
    z-index: 20;
    box-shadow: 0 0 64px 12px rgba($color: #ff0000, $alpha: 0.45),
      0 0 0 8px rgba($color: #da2323, $alpha: 0.10),
      0 0 0 4px rgba($color: #000000, $alpha: 0.10),
      0 0 0 2px rgba($color: #751313, $alpha: 0.10);
  }
  .fieldRow:nth-child(2n+1) {
    background-color: rgba($color: #000000, $alpha: 0.03);
  }
}
</style>
